import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// import { User } from '../../models/user';
import { Config } from 'src/app/config';

@Injectable()
export class UserService {
  constructor(private http: HttpClient, private config: Config) { }

  // Gets a list of all organizations for current user
  getOrganizationList() {
    return this.http.get<any[]>(this.config.getBaseUrl() + `/Api/User/organizations`);
  }

  // Gets a list of entities for current user; when orgId is provided, filters by organization
  getEntityList(orgId: string | null) {
    const url = this.config.getBaseUrl() + `/Api/User/entities`;
    if (orgId == null) {
      // Do not send organizationId when null
      return this.http.get<any[]>(url);
    }
    return this.http.get<any[]>(url, { params: { organizationId: orgId } });
  }



}